/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionDraftFormData } from './PalAuthSubmissionDraftFormData';
import {
    PalAuthSubmissionDraftFormDataFromJSON,
    PalAuthSubmissionDraftFormDataFromJSONTyped,
    PalAuthSubmissionDraftFormDataToJSON,
} from './PalAuthSubmissionDraftFormData';

/**
 *
 * @export
 * @interface AutosavePalAuthSubmission200ResponseData
 */
export interface AutosavePalAuthSubmission200ResponseData {
    /**
     *
     * @type {PalAuthSubmissionDraftFormData}
     * @memberof AutosavePalAuthSubmission200ResponseData
     */
    draft_form_data?: PalAuthSubmissionDraftFormData;
}

/**
 * Check if a given object implements the AutosavePalAuthSubmission200ResponseData interface.
 */
export function instanceOfAutosavePalAuthSubmission200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AutosavePalAuthSubmission200ResponseDataFromJSON(json: any): AutosavePalAuthSubmission200ResponseData {
    return AutosavePalAuthSubmission200ResponseDataFromJSONTyped(json, false);
}

export function AutosavePalAuthSubmission200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutosavePalAuthSubmission200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'draft_form_data': !exists(json, 'draft_form_data') ? undefined : PalAuthSubmissionDraftFormDataFromJSON(json['draft_form_data']),
    };
}

export function AutosavePalAuthSubmission200ResponseDataToJSON(value?: AutosavePalAuthSubmission200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'draft_form_data': PalAuthSubmissionDraftFormDataToJSON(value.draft_form_data),
    };
}

